/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BannerInfo } from '../models/BannerInfo';
import type { ExplorerHomeInfo } from '../models/ExplorerHomeInfo';
import type { HomeBannerInfo } from '../models/HomeBannerInfo';
import type { SearchHandlerInfo } from '../models/SearchHandlerInfo';
import type { SocialInfo } from '../models/SocialInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class GeneralControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns SocialInfo OK
     * @throws ApiError
     */
    public getGeneralSocialInfo({
        types,
    }: {
        types?: string,
    }): CancelablePromise<SocialInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/general/social',
            query: {
                'types': types,
            },
        });
    }

    /**
     * @returns SearchHandlerInfo OK
     * @throws ApiError
     */
    public getSearchHandler({
        term,
        filterBy = 'ALL',
    }: {
        term: string,
        filterBy?: 'ALL' | 'BLOCK' | 'TRANSACTION' | 'ADDRESS' | 'MODULE',
    }): CancelablePromise<Array<SearchHandlerInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/general/search/handler',
            query: {
                'filterBy': filterBy,
                'term': term,
            },
        });
    }

    /**
     * @returns HomeBannerInfo OK
     * @throws ApiError
     */
    public getHomeBannerList(): CancelablePromise<Array<HomeBannerInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/general/home/banner/list',
        });
    }

    /**
     * @returns ExplorerHomeInfo OK
     * @throws ApiError
     */
    public getSearchHandler1(): CancelablePromise<ExplorerHomeInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/general/explorer',
        });
    }

    /**
     * @returns BannerInfo OK
     * @throws ApiError
     */
    public getBannerInfo(): CancelablePromise<Array<BannerInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/general/banner/list',
        });
    }

}
